module.exports = {"360429100":"双钟镇","360429101":"流泗镇","360429102":"马影镇","360429103":"武山镇","360429104":"城山镇","360429105":"均桥镇","360429200":"大垅乡","360429201":"凰村乡","360429202":"张青乡","360429204":"付垅乡","360429205":"舜德乡","360429206":"流芳乡","360429500":"南北港水产场","360429501":"武山垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360429.json
// module id = 1274
// module chunks = 0